import React, { useEffect, useRef } from "react";
import { CellMeasurerCache, List } from "react-virtualized";
import { isNonEmptyArray } from "../../../../../../common/utils";
import VersioningDocumentRow from "./VersioningDocumentRow";
import { translate } from "../../../../../../common/providers";

const cache = new CellMeasurerCache({
	fixedWidth: true,
	defaultHeight: 32,
	minHeight: 32,
});
const getDocumentCountRecursive = (documents, selectedDoc) => {
	let totalCount = documents.filter((d) => !(d.type !== "FOLDER" && d.id === selectedDoc)).length;
	documents.forEach((document) => {
		if (isNonEmptyArray(document.documents) && document.expanded) {
			totalCount += getDocumentCountRecursive(document.documents, selectedDoc);
		}
	});
	return totalCount;
};
const VersioningDocumentList = ({
	containerWidth,
	documents,
	indentLevel = 0,
	mode,
	onCheck,
	onToggleExpand,
	selectedDocId,
	selectedRowId,
}) => {
	const listRef = useRef(null);
	const refreshRefCache = () => {
		cache.clearAll();
		listRef?.current?.recomputeRowHeights();
		listRef?.current?.forceUpdate();
		listRef?.current?.forceUpdateGrid();
	};
	useEffect(() => {
		window.addEventListener("resize", refreshRefCache);
		return () => {
			window.removeEventListener("resize", refreshRefCache);
		};
	}, []);
	useEffect(() => {
		refreshRefCache();
	}, [documents]);

	const rowRenderer = ({ index }) => {
		const document = documents[index];
		if (document.type !== "FOLDER" && document.id === selectedDocId) {
			return null;
		}
		return (
			<VersioningDocumentRow
				key={document.id || document.value}
				containerWidth={containerWidth - 12 || 0}
				document={document}
				indentLevel={indentLevel}
				isSelected={selectedRowId === document?.id}
				mode={mode}
				selectedDocId={selectedDocId}
				selectedRowId={selectedRowId}
				onCheck={onCheck}
				onToggleExpand={onToggleExpand}
			/>
		);
	};
	const noRowRenderer = () => <div>{translate("common:filters.document-tree.no-documents")}</div>;
	const getRowHeight = ({ index }) => {
		const currentDoc = documents[index];
		if (currentDoc.type !== "FOLDER" && currentDoc.id === selectedDocId) {
			return 0;
		}
		return currentDoc.expanded ? getDocumentCountRecursive([currentDoc], selectedDocId) * 32 : 32;
	};
	return (
		<>
			<List
				ref={(ref) => {
					listRef.current = ref;
				}}
				data-testid="gonogo.content.list"
				deferredMeasurementCache={cache}
				height={getDocumentCountRecursive(documents, selectedDocId) * 32}
				noRowsRenderer={noRowRenderer}
				overscanRowCount={5}
				rowCount={documents?.length || 0}
				rowHeight={getRowHeight}
				rowRenderer={rowRenderer}
				scrollToAlignment="start"
				width={containerWidth || 0}
			/>
		</>
	);
};

export default VersioningDocumentList;
